import { gql } from "@apollo/client";

const GET_INVOICE_DOCUMENT_UPLOAD_URLS = gql`
  query GetInvoiceDocumentUploadUrls($invoiceId: Int!, $filenames: [String]!) {
    getInvoiceDocumentUploadUrls(invoiceId: $invoiceId, filenames: $filenames) {
      success
      error
      urls {
        url
        key
        filename
      }
    }
  }
`;

const DELETE_INVOICE_DOCUMENT = gql`
  mutation DeleteInvoiceDocument($input: DeleteInvoiceDocumentInput!) {
    deleteInvoiceDocument(input: $input) {
      success
      error
    }
  }
`;

export { GET_INVOICE_DOCUMENT_UPLOAD_URLS, DELETE_INVOICE_DOCUMENT };
